import { AfterViewInit, Component, OnInit } from "@angular/core";
import { InsuranceHubService } from "../services/Insurance-hub.service";
import { OAuthService } from "angular-oauth2-oidc";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-insurance-widget",
  templateUrl: "./insurance-widget.component.html",
  styleUrls: ["./insurance-widget.component.css"],
  standalone: true,
  imports: [CommonModule, SharedModule, RouterModule]
})
export class InsuranceWidgetComponent implements OnInit, AfterViewInit {
  // Add this property for dynamic boxes
  UserPolicyDetails;
  coverTypes = [];
  userData = null;
  constructor(private insuranceHubService: InsuranceHubService,private oauthService: OAuthService,) { }
  ngOnInit(): void {
    this.userData = this.oauthService.getIdentityClaims();

    if (!this.userData) {
      if (localStorage.getItem('apiUserModel')) {
        this.userData = JSON.parse(localStorage.getItem('apiUserModel'));
      }
    }
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.GetPolicyDetails();
    }, 2000);
  }
  GetPolicyDetails() {

    this.insuranceHubService.GetUserPolicyListWithDetails().subscribe({
        next: (data: any) => {
      this.UserPolicyDetails = data;
      if (this.UserPolicyDetails?.creditLifePolicyResponse !== null) {
        this.coverTypes.push(this.UserPolicyDetails.creditLifePolicyResponse);
      }
      if (this.UserPolicyDetails?.lifeCoverPolicyResponse !== null) {
        this.coverTypes.push(this.UserPolicyDetails.lifeCoverPolicyResponse);
      }
      if (this.UserPolicyDetails?.legalCoverPolicyResponse !== null) {
        this.coverTypes.push(this.UserPolicyDetails.legalCoverPolicyResponse);
      }
      if (this.UserPolicyDetails?.funeralCoverPolicyResponse !== null) {
        this.coverTypes.push(this.UserPolicyDetails.funeralCoverPolicyResponse);
      }
    }});

  }

}
